import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'yellow' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
  block?: boolean;
}

export function Button({ variant = 'primary', block, className = '', children, ...props }: ButtonProps) {
  return <button className={`button button--${variant} ${block ? 'button--block' : ''} ${className}`} {...props}>{children}</button>;
}
